<template>
  <MobileContainer>
    <MobileHeader slot="header"
                  nav-action="home"
                  show-cart>
      Burger Boss - {{ restaurant.city }}
    </MobileHeader>
    <div :class="$style.main">
      <div :class="$style.mainTop">
        <img :class="$style.mainLogo"
             srcset="@/assets/img/LOGO@2x.png, @/assets/img/LOGO.png"
             src="@/assets/img/LOGO.png"
             alt="Burger Boss">

      </div>
      <div :class="$style.mainBottom">
        <VList :class="$style.productList">
          <template v-for="product in sortedProducts">
            <VListTile :key="product.key"
                       :class="$style.productListItem"
                       ripple
                       @click="openConfigurator(product.key)">
              <div :class="$style.productListItemContent">
                <p :class="$style.productListItemText">
                  {{ product.name }}
                  <span v-if="false"
                        :class="$style.newProductIcon">
                    new
                  </span>
                </p>
                <svg v-svg
                     :class="$style.iconPlus"
                     symbol="menu-btn-icon-plus"
                     size="28"/>
              </div>
            </VListTile>
          </template>
        </VList>
      </div>
    </div>
    <LoadingSpinner v-if="menuIsLoading" />
  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import { Getter, Action } from 'vuex-class';
import { CONFIGURATOR_PRODUCT } from '@/apps/configurator/store/types';
import { KidsMenu, FriesMenu, LazyMenuItems } from '@/apps/menu/constants';
import { menuItemsSorting } from '@/lib/helpers';
import LoadMenuMixin from '@/lib/mixins/load-menu-mixin';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';


/**
 * Mobile restaurant menu.
 */
@Component({
  components: {
    LoadingSpinner,
    MobileContainer,
    MobileHeader,
  },
  mixins: [
    LoadMenuMixin,
  ],
})
export default class MobileMenu extends Vue {
  @Getter('authUser') user;
  @Getter products;
  @Getter restByKey;
  @Getter restaurantId;
  @Action(CONFIGURATOR_PRODUCT) setCurrentProduct;

  restaurant = null;

  get userName() {
    return this.user ? this.user.firstName : 'Guest';
  }

  /* Get sorted products*/
  get sortedProducts() {
    return menuItemsSorting({
      ...this.products,
      ...LazyMenuItems,
    });
  }

  created() {
    this.restaurant = this.restByKey(this.restaurantId);
  }

  /**
   * Set product for configurator and redirect user to configurator page
   * @param productKey - key to set product from configurator.
   */
  async openConfigurator(productKey) {
    if (Object.keys(LazyMenuItems).includes(productKey)) {
      this.$router.push({
        name:   'lazy-menu',
        params: {
          baseProductKey: LazyMenuItems[productKey].productKey,
          lazyProductKey: productKey,
        },
      });

      return;
    }

    switch (productKey) {
      case KidsMenu.PRODUCT_ID:
        this.$router.push({ name: 'kids-menu' });
        break;

      case FriesMenu.PRODUCT_ID:
        this.$router.push({ name: 'fries-menu' });
        break;

      default:
        await this.setCurrentProduct({ productKey });
        this.$router.push({ name: 'configurator', params: { id: productKey } });
    }
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
@import "@/style/helpers.scss";

.main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  padding: 10px $mobile-content-side-padding 20px;

  &Top,
  &Bottom {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
}

.mainLogo {
  height: 169px;
  width: 169px;
  margin: auto 0;
}


.productList {
  width: 100%;
  max-width: 331px;

  &Item {
    min-height: 51px;
    width: 100%;

    a {
      padding: 0;

      @media (max-width: 480px) {
        &:hover {
          background-color: $white !important;
        }
      }
    }

    &Content {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid $green-color;
      border-radius: 2px;
      text-align: center;
      text-transform: uppercase;
      position: relative;
      padding: 16px 40px;

      .iconPlus {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
      }
    }

    &Text {
      color: $black-slightly-transparent;
      font-family: $main-font-family;
      font-weight: 700;
      font-size: rem(14px);
    }

    &+& {
      margin-top: 5px;
    }
  }

  .newProductIcon {
    height: 18px;
    width: 35px;
    border-radius: 9px;
    background-color: $green-color;
    display: inline-block;
    color: $white;
    font-family: $main-font-family;
    font-size: rem(10px);
    letter-spacing: rem(-0.24px);
    line-height: 18px;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileMenu.vue